// extracted by mini-css-extract-plugin
module.exports = {"blockWrapper":"CodeBlock_blockWrapper__Bc20g"};